// @ts-nocheck
// @ts-ignore
import React, { useEffect, useRef, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import HousePolicyCondition from "../../components/Property/HousePolicyCondition";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import NearByLocation from "../../components/Property/NearByLocation";
import DragAndDrop from "../../components/Property/DragAndDrop";
import GoogleMapPage from "../../components/Map/GoogleMap";
import { toast } from "react-toastify";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { URLS } from "../../Services/Constant";
import { get, post, put } from "../../Services/ApiHandler";
import moment from "moment";
import CurrentStepCard from "./CurrentStepCard";
import { formatOptionLabel } from "../../components/StaticData";
import { checkPermission } from "../redux/api/PermissionManager";
import { dummyimage } from "../../assets/img";

const PropertyReqEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const current_position = location?.state?.current_position;
  const admin_details = JSON.parse(localStorage.getItem("admin_details"));
  const [draggableImages, setDraggableImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [popup, setPopup] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [optionsList, setOptionsList] = useState({
    owners: [],
    hotelcategories: [],
    ageList: [],
    tagsList: [],
    policies: [],
    conditions: [],
  });
  const [locationList, setLocationsList] = useState({
    states: [],
    cities: [],
    areas: [],
  });
  const imgRef = useRef(null);

  const [formData, setFormData] = useState({
    ownerName: "",
    propertyName: "",
    HotelCategories: "",
    requestedBy: admin_details?.name,
    requestedtype: admin_details?.role_name,
    requestedOn: moment().format("DD/MM/YYYY"),
    propertyAddress: "",
    email: "",
    mobile: "",
    country: "India",
    state: "",
    city: "",
    area: "",
    landmark: "",
    managerNumber: "",
    address: "",
    longitude: "",
    latitude: "",
    tags: [],
    housePolicy: [],
    termsAndCondition: [],
    nearby_locations: [],
    age: "",
    description: "",
    front_image: "",
    reception_place: "",
  });

  const handleReject = async (data) => {
    const payload = { reject_reason: rejectReason };
    const res = await post(URLS.PROPERTY_MASTER + id + "/reject/", payload);
    console.log("reject property", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      navigate("/properties-rejected", { replace: true });
    }
  };

  useEffect(() => {
    getLocationsList(2);
    getOwnerList();
    getcategoriesList();
    getMastersList(2);
    getMastersList(13);
    getMastersList(14);
    getMastersList(15);
  }, []);

  //get  locations
  const getLocationsList = async (type, parent_id) => {
    let url = `${URLS.LOCATION + "?type=" + type}${
      parent_id ? "&parent_id=" + parent_id : ""
    }`;
    const res = await get(url);
    console.log("locations list", res, type, parent_id);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setLocationsList((prev) => ({ ...prev, states: modifiedList }));
      } else if (type === 3) {
        setLocationsList((prev) => ({ ...prev, cities: modifiedList }));
      } else {
        setLocationsList((prev) => ({ ...prev, areas: modifiedList }));
      }
    }
  };

  // get owners list
  const getOwnerList = async (search) => {
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    console.log("owner response success", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return {
          value: item?.id,
          label: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          ...item,
        };
      });
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  //   hotel categories
  // @ts-ignore
  const getcategoriesList = async (id) => {
    const res = await get(URLS.HOTELCATEGORIES_DROPDOWN);
    console.log("categories List", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.display_name };
      });
      setOptionsList((prev) => ({ ...prev, hotelcategories: modifiedList }));
    }
  };

  //get masters list
  const getMastersList = async (type) => {
    const res = await get(
      `${URLS.MASTER_DROPDOWN_URL}?type=${type}&page_size=100`,
    );
    console.log("masters list", type, res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      if (type === 2) {
        setOptionsList((prev) => ({ ...prev, tagsList: modifiedList }));
      }
      if (type === 13) {
        setOptionsList((prev) => ({ ...prev, policies: modifiedList }));
      }
      if (type === 14) {
        setOptionsList((prev) => ({ ...prev, ageList: modifiedList }));
      }
      if (type === 15) {
        setOptionsList((prev) => ({ ...prev, conditions: modifiedList }));
      }
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#F4F4F4",
      borderColor: state.isFocused ? "#333" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #333" : "none",
      "&:hover": {
        borderColor: "#333",
      },
    }),
  };
  // @ts-ignore
  const errors = {};
  const type =
    !checkPermission("CAN-EDIT-REQUESTED") &&
    !checkPermission("CAN-ADD-REQUESTED")
      ? "view"
      : location?.state?.type;
  const id = location?.state?.id;
  console.log("type", type);

  useEffect(() => {
    if (id) {
      viewProperty();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const viewProperty = async () => {
    const res = await get(URLS.PROPERTY_MASTER + id);
    console.log("view property", res);
    if (res?.status === "success") {
      let {
        address,
        ages,
        area,
        area_name,
        category,
        category_name,
        city,
        city_name,
        landmark,
        created_at,
        details,
        email,
        google_address,
        house_policies,
        images,
        latitude,
        longitude,
        manager_no,
        name,
        owner,
        owner_name,
        owner_mobile_no,
        state,
        state_name,
        tags,
        terms_conditions,
        front_image,
        reception_place,
      } = res?.data;
      getLocationsList(3, state);
      getLocationsList(4, city);
      const tag_ids = tags?.map((item) => {
        return { value: item?.master_id, label: item?.master__name };
      });
      const house_policies_ids = house_policies?.map((item) => {
        return { value: item?.master_id, label: item?.master__name };
      });
      const terms_conditions_ids = terms_conditions?.map((item) => {
        return { value: item?.master_id, label: item?.master__name };
      });

      setFormData((prev) => ({
        ...prev,
        ownerName: {
          id: owner,
          name: owner_name,
          email: email,
          mobile: owner_mobile_no,
        },
        propertyName: name,
        address: google_address,
        longitude: longitude,
        latitude: latitude,
        propertyAddress: address,
        age: ages?.[0]?.master_id,
        area: { id: area, name: area_name },
        city: { id: city, name: city_name },
        state: { id: state, name: state_name },
        landmark: landmark,
        country: "india",
        email: email,
        mobile: manager_no,
        managerNumber: manager_no,
        HotelCategories: { id: category, name: category_name },
        tags: tag_ids,
        housePolicy: house_policies_ids,
        termsAndCondition: terms_conditions_ids,
        requestedOn: moment(created_at).format("DD/MM/YYYY"),
        requestedBy: details?.requested_by_name,
        requestedtype: details?.requested_by_type,
        nearby_locations: details?.near_by_locations || [],
        description: details?.description,
        reception_place: reception_place,
        front_image: front_image,
      }));

      let images_arr = [];
      images?.forEach((item) => {
        if (item?.type === 1) {
          images_arr.push({ ...item, image: item?.image_name });
        }
      });
      setDraggableImages(images_arr.sort((a, b) => a.position - b.position));
    }
  };

  // console.log("form data", formData, draggableImages);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, val) => {
    setFormData((prev) => ({ ...prev, [name]: val }));
  };

  const handlePolicyConditionChange = (type, val, action) => {
    if (type === "policy") {
      if (action === "add") {
        // @ts-ignore
        setFormData((prev) => ({
          ...prev,
          housePolicy: [...prev.housePolicy, val],
        }));
        // @ts-ignore
        setOptionsList((prev) => ({
          ...prev,
          policies: prev?.policies?.filter(
            // @ts-ignore
            (item) => item?.value !== val?.value,
          ),
        }));
      } else {
        // @ts-ignore
        setFormData((prev) => ({
          ...prev,
          housePolicy: prev?.housePolicy?.filter(
            // @ts-ignore
            (item) => item?.value !== val?.value,
          ),
        }));
        // @ts-ignore
        setOptionsList((prev) => ({
          ...prev,
          policies: [...prev.policies, val],
        }));
      }
    } else {
      if (action === "add") {
        // @ts-ignore
        setFormData((prev) => ({
          ...prev,
          termsAndCondition: [...prev.termsAndCondition, val],
        }));
        // @ts-ignore
        setOptionsList((prev) => ({
          ...prev,
          conditions: prev?.conditions?.filter(
            // @ts-ignore
            (item) => item?.value !== val?.value,
          ),
        }));
      } else {
        // @ts-ignore
        setFormData((prev) => ({
          ...prev,
          termsAndCondition: prev?.termsAndCondition?.filter(
            // @ts-ignore
            (item) => item?.value !== val?.value,
          ),
        }));
        // @ts-ignore
        setOptionsList((prev) => ({
          ...prev,
          conditions: [...prev.conditions, val],
        }));
      }
    }
  };

  const handleSubmit = async (submit_type) => {
    // console.log("Data formdata", formData);
    if (!formData.ownerName?.name) {
      toast.error("Owner Name is required");
      return;
    }
    if (!formData.propertyName) {
      toast.error("Property Name is required");
      return;
    }
    if (!formData.HotelCategories?.name) {
      toast.error("Hotel Categories  is required");
      return;
    }
    // if (!formData.email || !emailRegex.test(formData.email)) {
    //   toast.error("Valid Email is required");
    //   return;
    // }
    if (!formData.country) {
      toast.error("Country is required");
      return;
    }
    if (!formData.state?.name) {
      toast.error("State is required");
      return;
    }
    if (!formData.city?.name) {
      toast.error("City is required");
      return;
    }
    if (!formData.area?.name) {
      toast.error("Area is required");
      return;
    }
    if (!formData.managerNumber) {
      toast.error("Manager Number is required");
      return;
    }

    if (!formData.landmark) {
      toast.error("Landmark  is required");
      return;
    }
    if (!formData.propertyAddress) {
      toast.error("Property Manual Address  is required");
      return;
    }
    if (!formData.address) {
      toast.error("Property Address  is required");
      return;
    }
    if (!formData.longitude) {
      toast.error("Logitude is required");
      return;
    }
    if (!formData.latitude) {
      toast.error("Latitude is required");
      return;
    }
    if (formData.tags.length === 0) {
      toast.error("Tags is required");
      return;
    }
    if (formData.housePolicy.length === 0) {
      toast.error("House Policy is required");
      return;
    }
    if (formData.termsAndCondition?.length === 0) {
      toast.error("Terms And Condition is required");
      return;
    }
    if (formData.nearby_locations.length === 0) {
      toast.error("Nearby Location is required");
      return;
    }
    // // Validate images
    if (draggableImages.length === 0) {
      toast.error("Please upload at least one property image");
      return;
    }
    if (!formData.age) {
      toast.error("Age is required");
      return;
    }

    if (!formData?.front_image) {
      toast.error("Main Image of Property Need It");
      return;
    }
    if (!formData?.reception_place) {
      toast.error("Reception Place Need It");
      return;
    }

    const {
      ownerName,
      propertyName,
      HotelCategories,
      state,
      city,
      area,
      landmark,
      longitude,
      latitude,
      address,
      propertyAddress,
      managerNumber,
      tags,
      housePolicy,
      termsAndCondition,
      age,
      nearby_locations,
      description,
      front_image,
      reception_place,
    } = formData;

    const payload = new FormData();
    payload.append("owner", ownerName?.id);
    payload.append("name", propertyName);
    payload.append("category", HotelCategories?.id);
    payload.append("country", 1);
    payload.append("state", state?.id);
    payload.append("city", city?.id);
    payload.append("area", area?.id);
    payload.append("latitude", latitude);
    payload.append("longitude", longitude);
    payload.append("address", propertyAddress);
    payload.append("google_address", address);
    payload.append("manager_no", managerNumber);
    payload.append("landmark", landmark);
    payload.append("age", age);
    payload.append("description", description);
    payload.append("front_image", front_image?.file);
    payload.append("reception_place", reception_place);

    payload.append("near_by_locations", JSON.stringify(nearby_locations));
    payload.append("tags_id", JSON.stringify(tags?.map((tag) => tag?.value)));
    payload.append(
      "house_policy",
      JSON.stringify(housePolicy?.map((policy) => policy?.value)),
    );
    payload.append(
      "terms_condition",
      JSON.stringify(termsAndCondition?.map((term) => term?.value)),
    );
    draggableImages?.forEach((img, ind) => {
      payload.append(
        `property_images${img?.id ? "_id" : ""}`,
        img?.id ?? img?.image,
      );
      payload.append("property_images_position", ind + 1);
    });

    payload.append("deleted_image_ids", deletedImages);
    let url =
      type === "edit"
        ? `${URLS.PROPERTY_EDIT + id}/edit/`
        : URLS.PROPERTY_MASTER + "add/";
    const urlMethod = type === "edit" ? put : post;
    const res = await urlMethod(url, payload);
    console.log("property add", res);
    if (res?.status === "success") {
      if (submit_type !== "submit") {
        handleAccept(res?.data);
      }
      if (submit_type === "submit") viewProperty();
      toast.success(res?.message);
    }
  };

  const handleAccept = async (data) => {
    console.log("handle accept", data);
    const res = await post(URLS.PROPERTY_MASTER + data?.id + "/accept/");
    console.log("accept property", res);
    if (res?.status === "success") {
      toast.success(res?.message);

      navigate("/propertie-doc-edit", {
        state: {
          type: "add",
          owner_id: formData?.ownerName?.id,
          id: data?.id,
          current_position: "verify",
        },
        replace: true,
      });
    }
  };
  const handleImageChange = (e) => {
    console.log("FileUPLOADdd", e);
    const file = e.target.files[0];

    if (file) {
      setFormData((prev) => ({
        ...prev,
        front_image: {
          file: file,
          preview: URL.createObjectURL(file),
        },
      }));
    }
  };
  return (
    <div>
      <Topbar header={"Properties"} subHead={"Requested"} />
      <CurrentStepCard />
      <div className="d-flex flex-wrap gap-5 mt-4">
        <PropertyReqFileds
          getOwnerList={getOwnerList}
          type={type}
          edit={type !== "view"}
          formData={formData}
          optionsList={optionsList}
          locationList={locationList}
          getLocationsList={getLocationsList}
          handleChange={handleChange}
          handleDropdownChange={handleDropdownChange}
          errors={errors}
          customStyles={customStyles}
        />
        <div className="w-90">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Map<span style={{ color: "red" }}>*</span>
          </p>
          <GoogleMapPage
            formData={formData}
            setFormData={setFormData}
            edit={type !== "view"}
            latlong={{
              lat: formData.latitude,
              lng: formData.longitude,
            }}
          />
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Latitude<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="latitude"
            value={formData?.latitude}
            onChange={handleChange}
            type="number"
            placeholder="Latitude"
          />
          {
            // @ts-ignore
            errors.latitude && <p className="err">{errors.latitude}</p>
          }
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Longitude<span style={{ color: "red" }}>*</span>
          </p>
          <input
            className="input-box"
            name="longitude"
            value={formData?.longitude}
            onChange={handleChange}
            type="number"
            placeholder="Longitude"
          />
          {
            // @ts-ignore
            errors.longitude && <p className="err">{errors.longitude}</p>
          }
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Tags<span style={{ color: "red" }}>*</span>
          </p>
          <Select
            isMulti
            name="tags"
            placeholder="Tags"
            value={formData.tags} // now stores array of selected options
            options={optionsList?.tagsList}
            onChange={(e) => {
              handleDropdownChange("tags", [...e]);
            }}
          />
          {
            // @ts-ignore
            errors.tags && <p className="err">{errors.tags}</p>
          }
        </div>
        <div className="col-md-5">
          <div>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Reception Place <span style={{ color: "red" }}>*</span>
            </p>
            <input
              className="input-box"
              name="reception_place"
              value={formData?.reception_place}
              onChange={handleChange}
              // type="number"
              // placeholder="Longitude"
              // disabled={!edit}
            />
          </div>
        </div>
        <HousePolicyCondition
          type={type}
          edit={type !== "view"}
          customStyles={customStyles}
          optionsList={optionsList}
          formData={formData}
          handlePolicyConditionChange={handlePolicyConditionChange}
          errors={errors}
        />
        <div className="col-md-5">
          <div>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
              Property Main Image<span style={{ color: "red" }}>*</span>
            </p>

            <div>
              {formData?.front_image?.preview || formData.front_image ? (
                <div style={{ position: "relative", width: "100px" }}>
                  <img
                    src={formData?.front_image?.preview || formData.front_image}
                    style={{
                      width: "100px",
                      height: "90px",
                      marginTop: 10,
                      cursor: "pointer",
                    }}
                    alt=""
                  />
                  <button
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        front_image: null,
                      }))
                    }
                    style={{
                      position: "absolute",
                      top: 0,
                      right: -10,
                      background: "red",
                      color: "white",
                      border: "none",
                      cursor: "pointer",
                      borderRadius: 19,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 20,
                      height: 20,
                    }}
                  >
                    X
                  </button>
                </div>
              ) : (
                <div>
                  <img
                    src={dummyimage}
                    style={{
                      width: "100px",
                      height: "90px",
                      marginTop: 10,
                      cursor: "pointer",
                      // objectFit: "contain",
                    }}
                    alt=""
                    onClick={() => imgRef.current?.click()}
                  />
                  <input
                    type="file"
                    className="input-pop mt-2 w-100 d-none"
                    accept="image/*"
                    onChange={(e) => handleImageChange(e)}
                    ref={imgRef}
                  />
                </div>
              )}{" "}
            </div>
          </div>
        </div>

        <div>
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ">
            Property Image<span style={{ color: "red" }}>*</span>
          </p>
          <p className="f2 fs-sm-8 fs-md-9 fs-lg-10 fs-xl-11 fs-xxl-14 mb-1 red">
            Max Upload Size : 5MB
          </p>
          <DragAndDrop
            edit={type !== "view"}
            errors={errors}
            draggableImages={draggableImages}
            setDraggableImages={setDraggableImages}
            setDeletedImages={setDeletedImages}
          />
        </div>
        <NearByLocation
          type={type}
          edit={type !== "view"}
          formData={formData}
          handleChange={handleChange}
          handleDropdownChange={handleDropdownChange}
          optionsList={optionsList}
          errors={errors}
        />
      </div>
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-jb  mb-4">
              <p className="f3 text-start fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15">
                Reason To Reject
              </p>
              <CloseSharpIcon
                onClick={() => {
                  setPopup(false);
                  setRejectReason("");
                }}
                className="pointer"
              />
            </div>
            <textarea
              style={{ minHeight: "160px", maxHeight: "300px" }}
              placeholder="Reason"
              className="input-box"
              value={rejectReason}
              onChange={(e) => setRejectReason(e.target.value)}
              id=""
            ></textarea>
            <div className="d-flex ac-je px-2 mt-5">
              <button
                onClick={() => {
                  handleReject();
                }}
                className="submit-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}Ok
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="d-flex ac-je mt-5">
        {/* <button onClick={() => navigate('/admin')} className="back-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 ">
                    Back
                </button> */}
        {current_position !== "request" &&
          checkPermission("CAN-EDIT-REQUESTED") && (
            <button
              onClick={() => {
                handleSubmit("submit");
              }}
              className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            >
              Submit
            </button>
          )}
      </div>
      {type !== "add" &&
        current_position === "request" &&
        checkPermission("CAN-EDIT-REQUESTED") && (
          <div className="d-flex ac-jb mt-4">
            <button
              onClick={() => {
                handleSubmit("accept");
              }}
              // onClick={() => navigate("/propertie-doc-edit", { state: { type: "edit" } })}
              className="accept-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 w-30"
            >
              Accept
            </button>
            <button
              onClick={() => setPopup(true)}
              className="reject-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 w-30"
            >
              Reject
            </button>
          </div>
        )}
      {type === "add" && checkPermission("CAN-ADD-REQUESTED") && (
        <div className="d-flex ac-je mt-5">
          <button
            onClick={() => {
              handleSubmit("add");
            }}
            // onClick={() => navigate('/propertie-doc-edit', { state: { type: "add" } })}
            className="accept-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 w-30"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default PropertyReqEdit;
